import { Injectable } from '@angular/core';
import { Subscription, BehaviorSubject, throwError, Observable } from 'rxjs';

// INTERFACES
import { IInvoiceType } from '../../../invoice/interfaces';

// SERVICES
import { EnvironmentUtilService } from '../util';

import { ApiService } from './api.service';

interface IResponse {
  data :IInvoiceType[];
  links :any;
  meta :any;
}

// INTERFACES
import { IInvoice } from '../../../invoice/interfaces/invoice.interface';
import { HttpParams } from '@angular/common/http';

import { IGetApiResponse } from '../../interfaces';

@Injectable({
  providedIn: 'root',
})
export class InvoiceApiService {
  private readonly _loading = new BehaviorSubject<boolean>(<boolean>false);
  private readonly _invoices = new BehaviorSubject<IInvoice[]>(<IInvoice[]>[]);
  private readonly _invoiceTypesLoading = new BehaviorSubject<boolean>(
    <boolean>false,
  );
  private readonly _invoiceTypes = new BehaviorSubject<IResponse>(<IResponse>{});
  loading$ = this._loading.asObservable();
  invoices$ = this._invoices.asObservable();
  invoiceTypesLoading$ = this._invoiceTypesLoading.asObservable();
  invoiceTypes$ = this._invoiceTypes.asObservable();

  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  get() :Subscription {
    this._loading.next(true);

    return this.apiService.get(`${this.environment.urlV1}/invoices`).subscribe({
      next: (response) => {
        this._loading.next(false);
      },
      error: (error) => throwError(() => new Error(error)),
    });
  }

  getInvoices(params :{ [param :string] :string | string[] | any }) :Subscription {
    this._loading.next(true);

    return this.apiService
      .get(`${this.environment.urlV1}/clients/purchase_orders`, {
        params,
      })
      .subscribe({
        next: (response :any) => {
          if (response?.data?.length > 0) {
            this._invoices.next(response.data);
          }
          this._loading.next(false);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }

  getInvoiceTypes(params :{ [param :string] :string | string[] }) :Subscription {
    this._invoiceTypesLoading.next(true);

    return this.apiService
      .get(`${this.environment.urlV2}/manage/client-purchase-order-type`, {
        params,
      })
      .subscribe({
        next: (response) => {
          this._invoiceTypes.next(response);
          this._invoiceTypesLoading.next(false);
        },
        error: (error) => throwError(() => new Error(error)),
      });
  }

  getDataById(
    id :number,
    params :{
      [param :string] :string | string[];
    },
  ) :Observable<any> {
    this._loading.next(true);

    return this.apiService.get(
      `${this.environment.urlV2}/orders/invoices/${id}/data`,
      {
        params,
      },
    );
  }
}
